__turbopack_context__.v({
  "admin-bg-danger": "Media-module-scss-module__pnfoaG__admin-bg-danger",
  "admin-bg-info": "Media-module-scss-module__pnfoaG__admin-bg-info",
  "admin-bg-primary": "Media-module-scss-module__pnfoaG__admin-bg-primary",
  "admin-bg-secondary": "Media-module-scss-module__pnfoaG__admin-bg-secondary",
  "admin-bg-success": "Media-module-scss-module__pnfoaG__admin-bg-success",
  "admin-bg-warning": "Media-module-scss-module__pnfoaG__admin-bg-warning",
  "admin-border": "Media-module-scss-module__pnfoaG__admin-border",
  "admin-border-dark": "Media-module-scss-module__pnfoaG__admin-border-dark",
  "admin-border-light": "Media-module-scss-module__pnfoaG__admin-border-light",
  "admin-rounded": "Media-module-scss-module__pnfoaG__admin-rounded",
  "admin-rounded-full": "Media-module-scss-module__pnfoaG__admin-rounded-full",
  "admin-rounded-lg": "Media-module-scss-module__pnfoaG__admin-rounded-lg",
  "admin-rounded-md": "Media-module-scss-module__pnfoaG__admin-rounded-md",
  "admin-rounded-sm": "Media-module-scss-module__pnfoaG__admin-rounded-sm",
  "admin-shadow-lg": "Media-module-scss-module__pnfoaG__admin-shadow-lg",
  "admin-shadow-md": "Media-module-scss-module__pnfoaG__admin-shadow-md",
  "admin-shadow-sm": "Media-module-scss-module__pnfoaG__admin-shadow-sm",
  "admin-sr-only": "Media-module-scss-module__pnfoaG__admin-sr-only",
  "admin-text-light": "Media-module-scss-module__pnfoaG__admin-text-light",
  "admin-text-muted": "Media-module-scss-module__pnfoaG__admin-text-muted",
  "admin-text-primary": "Media-module-scss-module__pnfoaG__admin-text-primary",
  "admin-text-secondary": "Media-module-scss-module__pnfoaG__admin-text-secondary",
  "media__caption": "Media-module-scss-module__pnfoaG__media__caption",
  "media__caption--no-title": "Media-module-scss-module__pnfoaG__media__caption--no-title",
  "media__container": "Media-module-scss-module__pnfoaG__media__container",
  "media__container--no-bottom": "Media-module-scss-module__pnfoaG__media__container--no-bottom",
  "media__container--no-top": "Media-module-scss-module__pnfoaG__media__container--no-top",
  "media__container--no-vertical": "Media-module-scss-module__pnfoaG__media__container--no-vertical",
  "media__grid": "Media-module-scss-module__pnfoaG__media__grid",
  "media__grid--col1": "Media-module-scss-module__pnfoaG__media__grid--col1",
  "media__grid--col2": "Media-module-scss-module__pnfoaG__media__grid--col2",
  "media__grid--col3": "Media-module-scss-module__pnfoaG__media__grid--col3",
  "media__image": "Media-module-scss-module__pnfoaG__media__image",
  "media__imageWrapper": "Media-module-scss-module__pnfoaG__media__imageWrapper",
  "media__item": "Media-module-scss-module__pnfoaG__media__item",
  "media__mediaWrapper": "Media-module-scss-module__pnfoaG__media__mediaWrapper",
  "media__title": "Media-module-scss-module__pnfoaG__media__title",
  "media__video": "Media-module-scss-module__pnfoaG__media__video",
  "media__videoWrapper": "Media-module-scss-module__pnfoaG__media__videoWrapper",
  "media__vimeo": "Media-module-scss-module__pnfoaG__media__vimeo",
  "media__vimeoWrapper": "Media-module-scss-module__pnfoaG__media__vimeoWrapper",
});
